import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { SUBSCRIPTION_TYPES } from '../redux/actions/user/Subscription';
import { Link } from 'react-router-dom';

function Success() {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch({
            type: SUBSCRIPTION_TYPES.CANCEL_SUBSCRIPTION_SUCCESS,
            payload: {
                success: false
            }
        })
    }, [dispatch]);
    return (
        <div className="bg-gray-900 h-screen flex items-center">
            <div className="bg-gray-300 p-6 rounded-[10px] w-[400px] md:mx-auto">
                <svg viewBox="0 0 24 24" className="text-green-600 w-16 h-16 mx-auto my-6">
                    <path fill="currentColor"
                        d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z">
                    </path>
                </svg>
                <div className="text-center">
                    <h3 className="md:text-2xl text-base text-gray-900 font-semibold text-center">Payment Done!</h3>
                    <p className="text-gray-900 mt-[8px]">Thank you for completing payment.</p>
                    <p className='text-gray-900'> Have a great day!  </p>
                    <div className="py-10 text-center">
                        <Link to="/" className="px-12 rounded-[10px] bg-gray-900 hover:bg-green-500 text-white font-semibold py-3">
                            GO BACK
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Success